import React from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { colors } from "../../design-system/colors";
import NotFound404Content from "./components/NotFound404Content";


export default function NotFound404(): JSX.Element {
  const navigate = useNavigate();
  const handleGoHome = (): void => {
    navigate(ROUTES.HOME);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(170deg, transparent 7.76%, ${colors.background.page404GlowOverlay} 91.68%), ${colors.background.page404}`,
        overflow: "hidden",
      }}
    >
      <NotFound404Content onGoHome={handleGoHome} />
    </Box>
  );
}
